<template>
  <div class="perm-placement-details">
    <div class="header">
      <div>Permanent Placement</div>
      <div>Reference# {{ permPlacement.reference_number }}</div>
    </div>
    <div class="perm-placement-details-section">
      <div class="perm-placement-left-section">
        <div class="contractor">
          <div class="name">{{ permPlacement.last_name }}, {{ permPlacement.first_name }}</div>
          <div><label>Invoice#: </label> {{ permPlacement.invoice_number }}</div>
          <div><label>Annual Salary: </label> ${{ permPlacement.salary }}</div>
          <div><label>Pay To: </label></div>
          <div><label>Fee Percentage: </label> {{ permPlacement.finders_percentage }}%</div>
          <div>
            <label>Billing Amount: </label> ${{ permPlacement.billing_amount }}
            {{ permPlacement.currency_code }}
          </div>
          <div><label>Taxes on Invoice: </label> {{ taxesOnInvoice }}</div>
          <div><label>Rebate: </label> {{ permPlacement.rebate }}</div>
          <div><label>Occupation: </label> {{ permPlacement.occupation }}</div>
        </div>
        <div class="agreement">
          <div class="name">{{ permPlacement.client_name }}</div>
          <div>
            <label>Bill To </label>
            <billing-method-display
              :data="permPlacement.billingMethod"
              @remove="removeOnScreenValue('BILLING_METHOD')"
            />
          </div>
        </div>
        <div class="client">
          <div>
            <label>Guarantee </label>{{ permPlacement.guarantee_amount }}
            {{ permPlacement.guarantee_unit }}
          </div>
          <div>
            <label>With Replacement </label>
            {{ permPlacement.guarantee_replacement ? 'Yes' : 'No' }}
          </div>
          <div>
            <label>Other Guarantee Agreement </label>
            {{ permPlacement.guarantee_other ? permPlacement.guarantee_other : 'none' }}
          </div>
        </div>

        <div class="comments">
          <div><label>Payment Comments </label>{{ permPlacement.payment_terms }}</div>
        </div>
        <label>TES' share of split</label>
        <div class="split-description">
          <div>
            <label>Split Description </label
            >{{ permPlacement.split_description ? permPlacement.split_description : 'none' }}
          </div>
        </div>
      </div>
      <div class="perm-placement-right-section">
        <div class="perm-placement">
          <div>
            <div class="perm-placement-header">
              <label>Branch</label> {{ permPlacement.branch_name }}
              {{ permPlacement.division_abbr ? permPlacement.division_abbr : '' }}
              <div :class="permPlacementColor">{{ permPlacement.status }}</div>
            </div>
          </div>
          <div><label>Start Date</label> {{ permPlacement.start_date }}</div>
          <div>
            <label>Client Transfer</label> {{ permPlacement.client_transfer ? 'Yes' : 'No' }}
          </div>
          <div>
            <label>Account Managers</label>
            <div v-for="item of permPlacement.stakeholderCommissions" :key="item.index">
              {{ item.commission_type == 'ACCOUNT_MANAGER' ? stakeHolderDisplay(item) : '' }}
            </div>
            <label>Recruiters</label>
            <div v-for="item of permPlacement.stakeholderCommissions" :key="item.index">
              {{ item.commission_type == 'RECRUITER' ? stakeHolderDisplay(item) : '' }}
            </div>
            <label>Commission Overrides</label>
            <div v-for="item of permPlacement.stakeholderCommissions" :key="item.index">
              {{ item.commission_type == 'OVERRIDE' ? stakeHolderDisplay(item) : '' }}
            </div>
          </div>
        </div>
        <div class="comments">
          <div>
            <label>General Comments </label>
            {{ permPlacement.created_comment ? permPlacement.created_comment : 'None' }}
          </div>
        </div>
        <div class="outsource">
          <div><label>Outsource Amount </label> {{ permPlacement.outsource_amount }}</div>
          <div><label>Paid To </label> {{ permPlacement.outsource_person }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  PermPlacementDetailsGetters,
  PermPlacementDetailsActions
} from '../perm-placement-details.keys';
import BillingMethodDisplay from '@/app/components/BillingMethodDisplay';
export default {
  name: 'PermPlacementDetailsPdf',
  components: {
    BillingMethodDisplay
  },
  computed: {
    permPlacement() {
      return this.$store.getters[PermPlacementDetailsGetters.CurrentPermPlacement];
    },
    taxesOnInvoice() {
      const taxOnInvoice =
        this.permPlacement.gst_on_invoice ||
        this.permPlacement.hst_on_invoice ||
        this.permPlacement.qst_on_invoice
          ? 'Yes '
          : 'No ';
      return taxOnInvoice
        .concat(this.permPlacement.gst_on_invoice ? 'GST ' : ' ')
        .concat(this.permPlacement.hst_on_invoice ? 'HST ' : ' ')
        .concat(this.permPlacement.qst_on_invoice ? 'QST' : '');
    },
    permPlacementColor() {
      switch (this.permPlacement.status) {
        case 'PROCESSED':
          return 'processed';
        case 'DRAFT':
          return 'draft';
        case 'SUBMITTED':
          return 'submitted';
      }
      return 'draft';
    }
  },
  mounted() {
    this.$store.dispatch(
      PermPlacementDetailsActions.RetrievePermPlacement,
      this.$route.params.referenceNumber
    );
  },
  methods: {
    stakeHolderDisplay(stakeHolder) {
      switch (stakeHolder.commission_type) {
        case 'ACCOUNT_MANAGER':
        case 'RECRUITER':
          return `
                    ${stakeHolder.display_name} 
                    #
                    ${stakeHolder.commission_number}
                    @ 
                    ${stakeHolder.split}
                    %`;
        case 'OVERRIDE':
          return stakeHolder.display_name + '#' + stakeHolder.commission_number;
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.perm-placement-details {
  padding: 10px;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: $grey;
    padding-top: 0px;
    padding-bottom: 10px;
    font-size: 1rem;
  }
  .name {
    font-weight: bold;
    padding-bottom: 10px;
  }

  div {
    padding-bottom: 2px;
    font-size: 0.9rem;
  }

  label {
    font-weight: bold;
  }

  .perm-placement-details-section {
    display: flex;
    flex-direction: row;

    .perm-placement-left-section {
      display: flex;
      flex-direction: column;
      width: 55%;
    }
    .perm-placement-left-section > * {
      margin: 0 0 0 0;
    }

    .perm-placement-left-section > div {
      margin: 3px 0 3px 0;
    }
    .contractor {
      border: 1px solid $black;
      padding: 10px;
    }
    .agreement {
      border: 1px solid $black;
      padding: 10px;
    }
    .client {
      border: 1px solid $black;
      padding: 10px;
    }
    .comments {
      border: 1px solid $black;
      padding: 10px;
    }
    .split-description {
      border: 1px solid $black;
      padding: 10px;
    }

    .perm-placement-right-section {
      display: flex;
      flex-direction: column;
      padding-left: 5px;
      width: 50%;

      div {
        margin: 3px 0 3px 0;
      }

      .perm-placement {
        border: 1px solid $black;
        padding: 10px;
      }

      .perm-placement-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      .outsource {
        border: 1px solid $black;
        padding: 10px;
      }

      .draft {
        background-color: $grey;
        color: $white;
      }

      .submitted {
        background-color: $orange;
        color: $white;
      }

      .processed {
        background-color: $blue;
        color: $white;
      }
    }
  }
}
</style>
